import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=ff684cfa"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports